import http from "../http-common-reclutamiento";

class ReclutamientoService {

    getUsuarioPorRut(rut) {
        return http.get(`/trabajador/${rut}`);
    }

    create(data) {
        return http.post("/trabajador",data);
    }

    updateTrabajador(id, data) {
        return http.put(`/trabajador/${id}`, data);
    }

    getAll() {
        return http.get('/trabajador');
    }
}

export default new ReclutamientoService();